import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const LinkedinCallback = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const getToken = async () => {
      try {
        const searchParams = new URLSearchParams(location.search);
        const code = searchParams.get("code");

        if (!code) {
          throw new Error("No authorization code found");
        }

        const response = await fetch(
          "https://platinumfuse.v2napi.com/api/oauth/token",
          {
            method: "POST",
            body: JSON.stringify({
              code: code,
              redirect_url: "http://localhost:3000/oauth/callback",
              role: "coach",
              meta: {
                onboarding: { complete: false, step: 1 },
              },
            }),
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();

        const coachToken = data?.token;
        localStorage.setItem("coachToken", coachToken);
        localStorage.setItem("browsercid", data?.user.id);
        localStorage.setItem("i", true);

        if (!response.ok) {
          throw new Error(data.message || "Failed to get token");
        }

        if (data.token) {
          localStorage.setItem("coachToken", data.token);
          if (data.user?.id) {
            localStorage.setItem("browsercid", data.user.id);
          }
          localStorage.setItem("i", true);
          navigate("/coaches/signup?basic_details=true&step=1");
        } else {
          throw new Error("No token received");
        }
      } catch (err) {
        console.error("LinkedIn callback error:", err);
        setError(err.message);
        toast.error(err.message || "Failed to complete LinkedIn registration");
        setTimeout(() => navigate("/signup"), 2000);
      } finally {
        setIsLoading(false);
      }
    };

    getToken();
  }, [location, navigate]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg text-center">
        {isLoading ? (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-700 mx-auto" />
            <p className="mt-4 text-gray-800 font-semibold">
              Processing LinkedIn registration...
            </p>
          </>
        ) : error ? (
          <p className="text-red-600 font-semibold">{error}</p>
        ) : (
          <p className="text-green-600 font-semibold">
            Registration successful! Redirecting...
          </p>
        )}
      </div>
    </div>
  );
};

export default LinkedinCallback;
